module.exports = __webpack_public_path__ + "img/new_empty.994c8381.png";